import { useEffect, useRef, useState } from "react";
import general, { imgPlaceholder } from "../../general";
import {
  CloseOutlined,
  FormOutlined,
  ShareAltOutlined,
  StarFilled,
  StarOutlined,
  ForwardOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import {
  useLocalStorageState,
  useLockFn,
  useMount,
  useReactive,
  useScroll,
  useSize,
  useThrottleEffect,
  useThrottleFn,
  useUpdateEffect,
} from "ahooks";
import { useHistory } from "react-router-dom";
import Index from "./detail/Index";
import Server from "./detail/Server";
import Activity from "./article/Groups";
import Comment from "./detail/Comment";
import Trade from "./detail/Trade";
import { Swiper, SwiperSlide } from "swiper/react";
import { CSSTransition } from "react-transition-group";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { NavLink } from "../../lib/Navigation";

import useActiveState from "../../lib/useActiveState";
import Dialog from "../../lib/Dialog";
import Image from "../../lib/Image";
import dayjs from "dayjs";
import useUrlState from "@ahooksjs/use-url-state";
import MobileDetect from "mobile-detect";
import { prod } from "../../config";
import URI from "urijs";
import qs from "qs";
import Super from "./ios/Super";
import SuperOld from "./ios/SuperOld";
import Intercept from "./ios/Intercept";
import Require from "./ios/Require";
import Auto from "./ios/Auto";
import Active from "../../lib/Active";
import _ from "lodash";
import $ from "jquery";

// 游戏详情页
const mobileDetect = new MobileDetect(navigator.userAgent);

const router = [
  {
    id: "index",
    component: Index,
    name: "详情",
  },
  {
    id: "comment",
    component: Comment,
    name: "评论",
    count: "",
  },
  {
    id: "activity",
    component: Activity,
    name: "活动",
  },
  {
    id: "trade",
    component: Trade,
    name: "交易",
  },
];

const Tips = (props) => {
  const [state, setState] = useLocalStorageState(
    `game-tips-${props.game.game_id}`
  );

  return (
    <>
      {!state ? (
        <>
          <div className="game-tips" onClick={() => setState(true)}>
            <div className="text">若游戏无法正常安装，请及时联系客服处理。</div>
            <CloseOutlined className="icon" />
          </div>
        </>
      ) : null}
    </>
  );
};

const spm = (spm) => general.axios.post("/spm", { spm });

export default (props) => {
  const history = useHistory();
  const [app] = useActiveState("app");
  const token = () => {
    let uri = new URI(window.location.hash.substring(1));
    let query = uri.query(true);
    if (query.udid && query.user_id && query.username && query.token) {
      localStorage.setItem("user_id", query.user_id);
      localStorage.setItem("username", query.username);
      localStorage.setItem("token", query.token);
      query.user_id = undefined;
      query.username = undefined;
      query.token = undefined;
      uri.query(query);
      console.warn(uri.toString());
      history.replace(uri.toString());
    }
  };
  useMount(token);
  useMount(history.listen(token));
  const [params] = useUrlState();
  const [config, setConfig] = useActiveState("config");
  const [key] = useActiveState("key");
  let [udid, setUdid] = useActiveState("udid");
  const [user] = useActiveState("user");
  let [agent] = useActiveState("agent");
  useEffect(() => {
    props.setTitle("");
    props.setOperate(
      <CopyToClipboard
        text={window.location.href}
        onCopy={() => Dialog.info("已复制链接")}
      >
        <ShareAltOutlined />
      </CopyToClipboard>
    );
  }, []);

  const [loading, setLoading] = useState(false);
  const [init, setInit] = useState(false);
  const [game, setGame] = useState();
  // 免签名下载按钮是否展示
  const [downloadSigning, setDownloadSigning] = useState(false);
  // 至尊版(需要超级签)下载按钮是否展示
  const [iosBtnShow, setIosBtnShow] = useState(true);
  // 下载走新代码还是旧代码
  const [isShowOld, setIsShowOld] = useState(0);
  const load = (parms = {}) => {
    if (loading) {
      return;
    }
    setLoading(true);
    let data = {};
    if (props.query.id) {
      data.game_id = props.query.id;
    } else if (props.query.mid) {
      data.maiyou_gameid = props.query.mid;
    } else {
      Dialog.error("缺少参数", 1, () => history.goBack);
      return;
    }
    general.axios
      .post("/base/game/getGameDetail", data)

      .then((res) => {
        let { status, data } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }

        setInit(true);
        let game = { ...data, ...data.game_info };
        if (game.game_feature_list) {
          let result = /<table[^>]*?>([\s\S]*)<\/table>/g.exec(
            game.game_feature_list[2].content
          );
          if (result && result[0]) {
            game.vipprice = result[0];
          }
        }
        if (game.status == 0) {
          game.cloud_support_type = null;
        }

        setGame(game);
        general.game = game;
        console.log("游戏详情", game);

        console.log(navRef.current?.clientHeight);
        console.log(barRef.current?.clientHeight);

        topHeight = navRef.current.clientHeight || 100;
        setTopHeight(navRef.current.clientHeight || 100);

        return general.axios.get("/base/game/isshowselfsign", {
          params: {
            game_id: game.maiyou_gameid,
          },
        });
      })
      .finally(() => {
        setLoading(false);
      })
      .then((res) => {
        console.log("是否展示免签名包体", res);
        let { status, data } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }

        setDownloadSigning(data.show);
        setIosBtnShow(data.iosshow);
        setIsShowOld(data.supershow);
      })
      .catch((err) => {
        // Dialog.error('getGameDetail ' + err.message);
      });
  };
  // useEffect(() => {
  //   load();
  // }, []);

  useEffect(() => {
    load();
  }, [localStorage.getItem("token")]);

  const [colour, setColour] = useState();
  const scroll = useScroll();

  const { run: _setColour } = useThrottleFn(
    (value) => {
      setColour(value);
    },
    { wait: 10 }
  );
  useEffect(() => {
    if (scroll && scroll.top) {
      let opacity = Math.abs(scroll.top) / 40;
      if (opacity > 1) {
        opacity = 1;
      }
      _setColour("rgba(255,255,255, " + opacity + ")");
    } else {
      _setColour("#202737");
    }
  }, [scroll, props.active]);

  useEffect(() => {
    history.listen((location) => {
      // console.log("请求路由路径变化了", location);
      Dialog.close();
    });
  });

  useUpdateEffect(() => {
    if (props.active && init) {
      if (scroll.top) {
        let opacity = Math.abs(scroll.top) / 40;
        if (opacity > 1) {
          opacity = 1;
        }
        setColour("rgba(255,255,255, " + opacity + ")");
        props.setTitle(
          <span style={{ opacity: opacity }}>
            {game?.game_name_main || game?.game_name}
          </span>
        );
      } else {
        setColour("#202737");
        props.setTitle(
          <span style={{ opacity: 0 }}>
            {game?.game_name_main || game?.game_name}
          </span>
        );
      }
    }
    if (props.active) {
      if (scroll?.top < -80) {
        load();
      }
    }
  }, [scroll, props.active]);

  const [routerIndex, setRouterIndex] = useState(
    parseInt(props.query.page) || 0
  );
  const [swiper, setSwiper] = useState(null);
  useEffect(() => {
    if (swiper) {
      swiper.update();
    }
  }, [props.active, swiper]);
  useEffect(() => {
    if (swiper) {
      swiper.slideTo(routerIndex);
    }
  }, [routerIndex, swiper]);

  const ref = useRef(null);

  const playCloudGame = (spm = "normal", assign = null, desktop = false) => {
    general.referrer = window.location.href;
    history.push(
      `/game/cloud?${qs.stringify({
        id: game.game_id,
        agent: localStorage.getItem("agent") || "x7z1",
        user: localStorage.getItem("user_id"),
        token: localStorage.getItem("token"),
        spm,
        assign,
        auto: desktop ? "desktop" : null,
      })}`
    );
  };

  const favorite = () => {
    setGame({ ...game, is_collected: !game.is_collected });
    general.axios
      .post(game.is_collected ? "/cancelCollectGame" : "/collectGame", {
        id: game.maiyou_gameid,
      })
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        let result = res.data;
        if (!result.status.succeed) {
          Dialog.error(result.status.error_desc);
        } else {
          Dialog.success("操作成功");
        }
      })
      .catch((err) => {
        Dialog.error("collectGame " + err.message);
      });
  };

  const download = useLockFn(async () => {
    if (
      mobileDetect.is("iPhone") ||
      mobileDetect.is("iPad") ||
      navigator.userAgent == "app" ||
      navigator.userAgent == "uniapp"
    ) {
      Dialog.loading();

      await general.axios
        .post(game.game_url.ios_url.replace("http", "https"))
        .finally(() => {
          Dialog.close();
        })
        .then((res) => {
          let { status, data } = res.data;
          if (!status.succeed) {
            Dialog.error(status.error_desc);
          } else {
            window.location.href = data.url;
          }
        })
        .catch((err) => {
          Dialog.error("game_url " + err.message);
        });
    } else {
      window.location.href = game.game_url.android_url;
    }
  });

  const reserve = () => {
    setGame({ ...game, is_reserved: !game.is_reserved });
    general.axios
      .post(game.is_reserved ? "/cancelReserveGame" : "/reserveGame", {
        id: game.maiyou_gameid,
      })
      .finally(() => {
        Dialog.close();
      })
      .then((res) => {
        let result = res.data;
        if (!result.status.succeed) {
          Dialog.error(result.status.error_desc);
        } else {
          Dialog.success("操作成功");
        }
      })
      .catch((err) => {
        Dialog.error("reserveGame " + err.message);
      });
  };

  const data = useReactive({
    auto: undefined,
    super: undefined,
    intercept: undefined,
    interceptCall: undefined,
    btns: undefined,
    interceptCallback: undefined,
  });
  useEffect(() => {
    if (params.auto && data.auto === undefined) {
      data.auto = params.auto;
    }
  }, [params.auto, data.auto]);

  useEffect(() => {
    data.btns =
      game?.cloud_support_type &&
      (mobileDetect.is("iPhone") ||
        mobileDetect.is("iPad") ||
        mobileDetect.match("Mac OS") ||
        navigator.userAgent == "app" ||
        navigator.userAgent == "uniapp");
  }, [game?.cloud_support_type]);

  // 拦截
  const intercept = (type, callback) => {
    console.log(type, callback);
    data.intercept = type;
    data.interceptCallback = callback;
  };

  const [udidSync, setUdidSync] = useLocalStorageState(
    `udid_sync_${dayjs().format("YYYYMMDDHHmm")}`
  );

  // 节流effect
  useThrottleEffect(async () => {
    console.log("进入详情页面");
    if (udidSync) {
      return;
    }
    setUdidSync(true);
    if (key && !udid) {
      await general.axios
        .post("/base/newindex/getKeyUdid", { key })
        .then(({ data: resData }) => {
          console.log("获取udid信息-----", resData);
          let { status, data } = resData;
          if (status.succeed && data.udid) {
            setUdid((udid = data.udid));
          }
        })
        .catch((error) => Dialog.error("setKeyUdid " + error.message));
    }
    if (udid && !config.udid_usable) {
      await general.axios
        .post("/base/common/getConfig")
        .then(({ data: resData }) => {
          let { status, data } = resData;
          if (status.succeed) {
            setConfig({ ...config, udid_usable: data.udid_usable });
          }
        })
        .catch((error) => console.error(error));
    }
    setUdidSync(true);
  }, [key, udid, config.udid_usable, udidSync]);

  const [tipsed, setTipsed] = useLocalStorageState(
    `game_tips_${props.query.id || props.query.mid}_${dayjs().format("YYYYMM")}`
  );

  const [standalone] = useLocalStorageState("standalone");

  // 免签名下载
  const [giftShow, setGiftShow] = useState(false);
  const [isClick, setIsClick] = useState(true);
  const signingDownload = () => {
    if (isClick) {
      setIsClick(false);
      setGiftShow(true);
      Dialog.loading();

      let data = {};
      data.game_id = game.maiyou_gameid;
      data.app_id = game.game_id;
      data.ag = localStorage.getItem("agent") || "x7z1";

      general.axios
        .get("/base/game/selfsigndownload", {
          params: {
            ...data,
          },
        })
        .then((res) => {
          console.log("下载免签名包体", res);
          let { status, data } = res.data;
          if (!status.succeed) {
            Dialog.error(status.error_desc);
            return;
          }

          window.location.href = data.url;
          setTimeout(() => {
            Dialog.close();
          }, 3000);
          setIsClick(true);
        })
        .catch((err) => {
          setIsClick(true);
          Dialog.close();
          // Dialog.error('getGameDetail ' + err.message);
        });
    }
  };

  // 点击至尊版下载
  const downloadGame = _.throttle(() => {
    console.log("至尊版下载");

    if (game.specialized?.button_name) {
      Dialog.welfare(
        game.specialized.pop_title,
        <div
          dangerouslySetInnerHTML={{
            __html: game.specialized.content,
          }}
        ></div>,
        () => {
          console.log("前往领取");
          window.location.href = game.specialized.url;
        },
        () => {
          console.log("----------");
          if (game.specialized.is_show_down == 1) {
            if (data.btns && !tipsed) {
              setTipsed(true);
            }
            intercept("super", () => (data.super = true));
            spm(`game.${game.maiyou_gameid}.download`);
          }
        },
        {
          btn: "前往领取",
          btnDown: game.specialized.is_show_down == 1 ? "直接下载" : "",
        }
      );
    } else {
      if (data.btns && !tipsed) {
        setTipsed(true);
      }
      intercept("super", () => (data.super = true));
      spm(`game.${game.maiyou_gameid}.download`);
    }
  }, 3000);

  let [topHeight, setTopHeight] = useState(100);
  const navRef = useRef();
  const barRef = useRef();

  const [serverShow, setServerShow] = useState(false);
  const [jurisdictionShow, setJurisdictionShow] = useState(false);

  return (
    <>
      <div
        className={`game-detail ${
          navigator.userAgent == "app" || navigator.userAgent == "uniapp"
            ? "no-video"
            : ""
        }`}
        ref={ref}
      >
        {game && !props.loading ? (
          <>
            <div className="game-body">
              <div
                className="status-bar-background statusBar"
                ref={barRef}
                style={{
                  backgroundImage: colour
                    ? `linear-gradient(${colour},${colour})`
                    : "linear-gradient(rgba(204, 204, 204, 0.95),rgba(204, 204, 204, 0))",
                }}
              />

              <div
                className="game-nav fixed"
                ref={navRef}
                style={colour ? { backgroundColor: colour } : null}
              >
                <div
                  className="game-nav-item leftIcon"
                  style={{ color: colour == "#202737" ? "#fff" : "#000" }}
                  onClick={() => general.history.goBack()}
                >
                  <LeftOutlined
                    style={{ fontSize: "18px", paddingTop: "5px" }}
                  />
                </div>

                {router.map((item, index) => {
                  let count = 0;
                  if (item.id == "comment") {
                    count = game?.game_comment_num;
                  }
                  return (
                    <div
                      key={index}
                      className={
                        "game-nav-item game-nav-" +
                        item.id +
                        " " +
                        (routerIndex == index ? "active" : "")
                      }
                      style={{ color: colour == "#202737" ? "#fff" : "#000" }}
                      onClick={() => {
                        $("html,body").animate({ scrollTop: 0 }, 200);
                        setRouterIndex(index);
                      }}
                    >
                      <div className="text">
                        {item.name}
                        {count && count > 0 ? (
                          <div
                            className="count"
                            style={{
                              color: colour == "#202737" ? "#fff" : "#000",
                            }}
                          >
                            {count > 99 ? "99+" : count}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  );
                })}
              </div>

              <div
                className="game-main"
                style={{ paddingTop: topHeight + "px" }}
              >
                <Swiper
                  allowTouchMove={false}
                  onSwiper={setSwiper}
                  onSlideChange={(swiper) => setRouterIndex(swiper.activeIndex)}
                >
                  {router.map((item, index) => (
                    <SwiperSlide key={index}>
                      <div
                        className={
                          "game-main-item game-main-" +
                          item.id +
                          " " +
                          (routerIndex === index ? "active" : "")
                        }
                      >
                        <Active active={props.active && routerIndex === index}>
                          <item.component
                            active={props.active && routerIndex === index}
                            game={
                              game
                                ? game
                                : { game: { game_id: props.query.id } }
                            }
                            setGame={setGame}
                            load={load}
                            setServerShow={setServerShow}
                            setJurisdictionShow={setJurisdictionShow}
                          />
                        </Active>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
            <div className="game-operate width">
              <Tips game={game} />
              {/* 非线上环境及测试环境显示 速启云 游上云 企业签*/}
              {/* {!prod ? (
                <>
                  <div className="test">
                    <NavLink
                      className="btn"
                      onClick={() => playCloudGame("test", "sq")}
                    >
                      速启云
                    </NavLink>
                    <NavLink
                      className="btn"
                      onClick={() => playCloudGame("test", "ys")}
                    >
                      游上云
                    </NavLink>
                    {mobileDetect.is("iPhone") || mobileDetect.is("iPad") ? (
                      <>
                        <div className="btn" onClick={download}>
                          企业签
                          {game.game_size?.ios_size && (
                            <div className="size">
                              {game.game_size?.ios_size}
                            </div>
                          )}
                        </div>
                      </>
                    ) : null}
                  </div>
                </>
              ) : null} */}
              <div className="container">
                <NavLink
                  className={
                    "favorite-container " + (game.is_collected ? "active" : "")
                  }
                  onClick={favorite}
                >
                  <img
                    src="/resources/game/notLike.png"
                    alt=""
                    className="icon favorite"
                  />
                  <img
                    src="/resources/game/like.png"
                    alt=""
                    className="icon favorited"
                  />
                  收藏
                </NavLink>
                <div className={`btns ${data.btns ? "multiple" : ""}`}>
                  {game.game_species_type == 3 ? (
                    <>
                      <NavLink
                        className="btn"
                        to={`${game.game_url.android_url}&screen=${game.screen_orientation}`}
                        iframe={{ title: game.game_name }}
                      >
                        开始玩
                      </NavLink>
                    </>
                  ) : (
                    <>
                      {/* iOS */}
                      {mobileDetect.is("iPhone") ||
                      mobileDetect.is("iPad") ||
                      mobileDetect.match("Mac OS") ||
                      navigator.userAgent == "app" ||
                      navigator.userAgent == "uniapp" ? (
                        <>
                          {/* 免签名下载 */}
                          {downloadSigning && (
                            <>
                              {(() => {
                                // 是否需要登录才可下载
                                let user =
                                  config.ios_guest_downloadable !== true;
                                if (
                                  user &&
                                  !navigator.standalone &&
                                  !standalone
                                ) {
                                  user = !udid;
                                }
                                return (
                                  <NavLink
                                    className="btn"
                                    user={user && agent !== "3rem"}
                                    onClick={() => {
                                      signingDownload();
                                      spm(
                                        `game.${game.maiyou_gameid}.download`
                                      );
                                    }}
                                  >
                                    <span className="text">下载(推荐)</span>
                                    {game.game_size?.ios_size && (
                                      <div className="size">
                                        {game.game_size?.ios_size}
                                      </div>
                                    )}
                                  </NavLink>
                                );
                              })()}
                            </>
                          )}

                          {/* 云玩 */}
                          {game.cloud_support_type ? (
                            <>
                              <NavLink
                                className="btn btn-cloud"
                                onClick={() => {
                                  intercept("cloud", playCloudGame);
                                  spm(`game.${game.maiyou_gameid}.cloud`);
                                }}
                              >
                                <div className="icon">
                                  <img
                                    src="/resources/game/cloud.png"
                                    alt="云玩"
                                  />
                                </div>
                                <div className="text">云玩</div>
                              </NavLink>
                            </>
                          ) : null}

                          {/* 至尊版下载 */}
                          {iosBtnShow && game.downButton?.Super && (
                            <>
                              {(() => {
                                let user =
                                  config.ios_guest_downloadable !== true;
                                if (
                                  user &&
                                  !navigator.standalone &&
                                  !standalone
                                ) {
                                  user = !udid;
                                }
                                return (
                                  <NavLink
                                    className="btn"
                                    user={user && agent !== "3rem"}
                                    onClick={downloadGame}
                                  >
                                    {game.specialized?.button_name ? (
                                      <>
                                        <span className="text">
                                          {game.specialized.button_name}
                                        </span>
                                        {game.game_size?.ios_size && (
                                          <div className="size">
                                            {game.game_size?.ios_size}
                                          </div>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {data.btns && !tipsed && (
                                          <div className="tips">
                                            下载客户端更稳定
                                          </div>
                                        )}
                                        <div className="text">
                                          至尊版下载
                                          {data.btns && "(推荐)"}
                                        </div>
                                        {game.game_size?.ios_size && (
                                          <div className="size">
                                            {!data.btns &&
                                              game.game_size?.ios_size}
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </NavLink>
                                );
                              })()}
                            </>
                          )}
                          {/* 首发提醒 */}
                          {game.status == 0 && (
                            <>
                              <NavLink
                                className="btn btn-reserve"
                                onClick={reserve}
                              >
                                {game.is_reserved ? (
                                  <h1>取消提醒</h1>
                                ) : (
                                  <>
                                    <h2>开启首发提醒</h2>
                                    <p>
                                      {dayjs
                                        .unix(game.starting_time)
                                        .format("MM-DD HH:mm")}
                                      首发
                                    </p>
                                  </>
                                )}
                              </NavLink>
                            </>
                          )}
                        </>
                      ) : (
                        // 安卓
                        <>
                          {game.specialized?.button_name ? (
                            <div
                              className="btn"
                              onClick={() => {
                                Dialog.welfare(
                                  game.specialized.pop_title,
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: game.specialized.content,
                                    }}
                                  ></div>,
                                  () => {
                                    console.log("前往领取");

                                    window.location.href = game.specialized.url;
                                  },
                                  () => {
                                    console.log("----------");
                                    if (game.specialized.is_show_down == 1) {
                                      download();
                                      spm(
                                        `game.${game.maiyou_gameid}.download`
                                      );
                                    }
                                  },
                                  {
                                    btn: "前往领取",
                                    btnDown:
                                      game.specialized.is_show_down == 1
                                        ? "直接下载"
                                        : "",
                                  }
                                );
                              }}
                            >
                              <span className="text">
                                {game.specialized.button_name}
                              </span>
                            </div>
                          ) : (
                            <div
                              className="btn"
                              onClick={() => {
                                download();
                                spm(`game.${game.maiyou_gameid}.download`);
                              }}
                            >
                              <span className="text">下载</span>
                              <div className="size">
                                {game.game_size?.android_size}
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
                <NavLink
                  to={"/comment/submit?id=" + game.comment_topic_id}
                  className="appraise"
                >
                  <img
                    src="/resources/game/comment.png"
                    alt=""
                    className="icon"
                  />
                  点评
                </NavLink>
              </div>
            </div>
          </>
        ) : (
          <div className="game-skeleton">
            <div className="a" />
            <div className="b">
              <img src={imgPlaceholder.default} />
            </div>
          </div>
        )}

        {data.auto && game ? (
          <>
            <Require reject={() => (data.auto = false)}>
              <Auto
                game={game}
                type={data.auto === "desktop" ? "cloud" : data.auto}
                close={() => (data.auto = false)}
                callback={
                  data.auto === "cloud" || data.auto === "desktop"
                    ? () => playCloudGame("auto", null, data.auto === "desktop")
                    : () => (data.super = true)
                }
                superGo={() => (data.super = true)}
                cloud={() => playCloudGame("auto")}
              />
            </Require>
          </>
        ) : null}
        {data.super ? (
          <>
            <Require reject={() => (data.super = false)}>
              {isShowOld === 1 ? (
                <Super game={game} close={() => (data.super = false)} />
              ) : (
                <SuperOld game={game} close={() => (data.super = false)} />
              )}
            </Require>
          </>
        ) : null}
        {data.intercept ? (
          <>
            <Require reject={() => (data.intercept = false)}>
              <Intercept
                game={game}
                type={data.intercept}
                close={() => (data.intercept = false)}
                callback={data.interceptCallback}
                superGo={() => (data.super = true)}
                cloud={() => playCloudGame("confirm")}
              />
            </Require>
          </>
        ) : null}
      </div>

      {game && !props.loading && (
        <CSSTransition in={giftShow} timeout={250} unmountOnExit={true}>
          <div className="gift-detail">
            <div className="gift-mask" />
            <div className="gift-container" style={{ height: "auto" }}>
              <div className="gift-top">
                <div className="down-title">下载小贴士</div>
                <img
                  style={{ width: "16px", height: "16px" }}
                  src="/resources/game/close.png"
                  alt=""
                  onClick={() => {
                    setGiftShow(false);
                  }}
                />
              </div>
              <div className="gift-main">
                <div className="down-desc">
                  <p className="down-every">
                    1.同意安装后，将自动在桌面上开始安装
                  </p>
                  <div className="down-every down-schedule-img">
                    <div className="schedule-img">
                      <Image className="gameImg" src={game.game_image?.thumb} />
                      <div className="black">
                        <img src="/resources/detail/down01.png" alt="" />
                      </div>
                    </div>
                    <ForwardOutlined
                      style={{ color: "#ffc000", fontSize: "38px" }}
                    />
                    <div className="schedule-img">
                      <Image className="gameImg" src={game.game_image?.thumb} />
                      <div className="black">
                        <img src="/resources/detail/down02.png" alt="" />
                      </div>
                    </div>
                    <ForwardOutlined
                      style={{ color: "#ffc000", fontSize: "38px" }}
                    />
                    <div className="schedule-img">
                      <Image className="gameImg" src={game.game_image?.thumb} />
                      <div className="black">
                        <img src="/resources/detail/down03.png" alt="" />
                      </div>
                    </div>
                    <ForwardOutlined
                      style={{ color: "#ffc000", fontSize: "38px" }}
                    />
                    <div className="schedule-img">
                      <Image className="gameImg" src={game.game_image?.thumb} />
                    </div>
                  </div>
                  <p className="down-every">
                    2.游戏安装完成后，请前往设置-通用-VPN与设备管理-信任企业级应用
                  </p>
                  <p className="down-every" style={{ color: "red" }}>
                    3.如提示无法安装或无法验证游戏，请点击“至尊版下载”进行使用
                  </p>
                  <p className="down-every">4.如有疑问请联系APP客服咨询</p>
                </div>
              </div>
              <div
                className="gift-bottom"
                style={{ marginTop: "30px" }}
                onClick={() => setGiftShow(false)}
              >
                我知道了
              </div>
            </div>
          </div>
        </CSSTransition>
      )}

      <CSSTransition in={serverShow} timeout={250} unmountOnExit={true}>
        <div className="server-region-content">
          <div
            className="server-mask"
            onClick={() => {
              setServerShow(false);
            }}
          />
          <div className="server-main">
            <div className="gift-top">
              <div className="down-title" style={{ paddingLeft: "46px" }}>
                开服表
              </div>
              <img
                style={{ width: "16px", height: "16px" }}
                src="/resources/game/close.png"
                alt=""
                onClick={() => {
                  setServerShow(false);
                }}
              />
            </div>
            <Server game={game} />
          </div>
        </div>
      </CSSTransition>

      <CSSTransition in={jurisdictionShow} timeout={250} unmountOnExit={true}>
        <div className="server-region-content">
          <div
            className="server-mask"
            onClick={() => {
              setJurisdictionShow(false);
            }}
          />
          <div className="server-main">
            <div style={{ position: "relative", paddingBottom: "16px" }}>
              <div className="gift-top">
                <div className="down-title">权限信息</div>
              </div>
              <div
                className="jur-main"
                dangerouslySetInnerHTML={{
                  __html: game?.game_control_info?.authority_info,
                }}
              ></div>
              <div className="jur-btn">
                <div
                  className="btn-main"
                  onClick={() => {
                    setJurisdictionShow(false);
                  }}
                >
                  我知道了
                </div>
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>
    </>
  );
};
